// Maybe do something with constants

export const FIREBASE = "FIREBASE";
export const UNSPLASH = "UNSPLASH";
export const GOOGLEAPIKEY = "GOOGLEAPIKEY";
export const EMAILFORSIGNIN = "EMAILFORSIGNIN"; // 邮件验证，已提交的的邮件地址
export const BENTOUSER = "BENTOUSER"; // 用户信息
